import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useHistory } from "react-router-dom";
import "../../Assets/developer.css";
import { useState } from "react";

export default function CreateStepOneSurvey() {
  const navigate = useNavigate();
  const [surveyorName, setSurveyorName] = useState("");
  const [applicationNumber, setApplicationNumber] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [email, setEmail] = useState("");
  const [onRent, setOnRent] = useState("");
  const [address, setAddress] = useState("");
  const [connectionStatus, setConnectionStatus] = useState("");
  const saveSurvey = async (e) => {
    console.log(connectionStatus);
    //Swal.fire({ surveyorName });
  };
  return (
    <div className="container">
      <div className="row mt-5">
        <div className="col-lg-6 justify-content-center form-center">
          <div className="form-top-design">
            <form>
              <div className="form-group">
                <label for="surveyor_name">Meter No.</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setSurveyorName(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Meter Reading</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setApplicationNumber(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">Meter Photo</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setCustomerName(event.target.value)}
                ></input>
              </div>
              <div className="form-group">
                <label for="surveyor_name">
                  Photo of Kitchen Point Gas Tap/Plug
                </label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(event) => setMobileNumber(event.target.value)}
                ></input>
              </div>
              <div className="form-group elements-div">
                <input
                  type="button"
                  name="submit"
                  value="Next"
                  className="next-button"
                  onClick={saveSurvey}
                ></input>
                <button className="next-button" onClick={() => navigate(-1)}>
                  Back
                </button>
                <a href="#" className="clear-link">
                  Clear
                </a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
